/*!
 * Copyright (c) Microsoft Corporation and contributors. All rights reserved.
 * Licensed under the MIT License.
 */
/**
 * Document access to underlying storage. It is default implementation of a storage service.
 * Does not read/write anything.
 */
export class NullBlobStorageService {
    async getSnapshotTree(version) {
        return version ? Promise.reject(new Error("Invalid operation")) : null;
    }
    async getVersions(versionId, count) {
        return [];
    }
    async uploadSummaryWithContext(summary, context) {
        throw new Error("Invalid operation");
    }
    async downloadSummary(handle) {
        throw new Error("Invalid operation");
    }
    async createBlob(file) {
        throw new Error("Null blob storage can not create blob");
    }
    async readBlob(blobId) {
        throw new Error("Null blob storage can not read blob");
    }
}
//# sourceMappingURL=nullBlobStorageService.js.map